import React from 'react'
import style from '../../../styles/mystyle.module.css'
// import { Header } from '../Layout/Header'
// import TabBasket from './TabBasket'
import MedicalCard from './MedicalCard'
import {Navbar} from '../Layout/Navbar'


function Main() {
  return (
    <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>

     
      <Navbar showDownloadAppSection={false} exchangeAllCurrenciesCallBack={(res)=>(res)} currenciesCallBack={(res)=>(res)}>

      <MedicalCard type={"products"} />
  
      <div className={style.paddingBottom}></div>
    
      </Navbar>

    </div>
  )
}

export default Main
